import React from 'react';
import styles from './Features.module.css';

const Features = () => {
  const features = [
    {
      title: "Smart Betting Analytics",
      description: "Real-time odds tracking and analysis across multiple bookmakers",
      icon: "📊"
    },
    {
      title: "Account Management",
      description: "Intelligent stake calculation and account health monitoring",
      icon: "💼"
    },
    {
      title: "Promotional System",
      description: "Complete promotional tracking with automated calculations",
      icon: "🎯"
    },
    {
      title: "Expert Tips",
      description: "Professional analysis and predictions with proven track record",
      icon: "🏆"
    },
    {
      title: "Support",
      description: "Get assistance through our dedicated Discord community",
      icon: "🌟"
    }
  ];

  // Create four copies of features for seamless infinite scroll
  const allFeatures = [...features, ...features, ...features, ...features, ...features, ...features, ...features, ...features, ...features, ...features, ...features, ...features];

  return (
    <section className={styles.featuresSection}>
      <h2 className={styles.title}>Our Features</h2>
      <div className={styles.carouselContainer}>
        <div className={styles.carousel}>
          <div className={styles.carouselTrack}>
            {allFeatures.map((feature, index) => (
              <div key={index} className={styles.feature}>
                <div className={styles.featureIcon}>{feature.icon}</div>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
                <p className={styles.featureDescription}>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;